<template>
  <div>
    <div class="modal__content">
      <p class="mb20">Amount that we need to pay: ${{debtMoney}}</p>

      <div class="form-row">
        <label for="pay">Amount that we already paid</label>
        <input class="form-control" type="number" id="pay" v-model="paymentAmount" placeholder="$0">
      </div>

      <div class="flex">
        <button class="btn btn--gray-2 flex__fill-gap mr10" @click="$bus.$emit('modalClose')" type="button">Close
        </button>
        <button class="btn flex__fill-gap" @click="onConfirm">Confirm</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    data () {
      return {
        paymentAmount: null,
        debtMoney: null
      }
    },

    props: {
      args: {
        type: Object,
        required: true
      }
    },

    created () {
      this.init()
    },

    methods: {
      init () {
        this.debtMoney = this.args.debtMoney
      },

      onConfirm () {
        this.$bus.$emit('userPayment', this.args.userId, this.paymentAmount, this.debtMoney)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PaymentUserModal.vue?5b9f65d6